import React from 'react';
import findIndex from 'lodash/findIndex';
import { CircleMinusMinor, CirclePlusMinor } from '@shopify/polaris-icons';
import { isDefaultTitle } from '../../../utilities/helperUtility';
import { convertDateFormat, formatHours } from '../../../utilities/timeUtility';
import Translation, { rtlRegions } from '../../../utilities/localizationUtility';
import FormCheckbox from '../../../../components/components/common/form_checkbox_without_polaris.js';
import dayjs from '../../../../dayjs/dayjs_timezone';
import Icon from '../../../components/Icon';
import { MultipleAppointmentsWrapper, StyledButton } from './MultipleAppointments.style';

function MultipleAppointments(props) {
  const {
    actions,
    bodyStyles: { fontSize: font },
    buttonStyles,
    isSlotAvailable,
    locale,
    multipleAppointmentsEnabled,
    multipleSlotsCount,
    multipleOccurrences,
    options,
    region,
    setting,
    style,
    timeSlots,
    timeSlot,
    timeZone,
    variants,
    variantSelected,
  } = props;

  if (!(multipleAppointmentsEnabled && multipleOccurrences)) return '';

  const getMax = () => {
    return multipleOccurrences.max;

    if (multipleOccurrences.type !== 1) return multipleOccurrences.max;

    const selectedVariant = variants.find((v) => v.external_id === variantSelected);
    const { option_multiple_occurrences: optionOccurrences } = multipleOccurrences;
    if (!selectedVariant) return 1;

    const optionIdx = findIndex(options, (o) => o.name === multipleOccurrences.option);
    let multipleOccurrence = optionOccurrences.find((o) => o.value === selectedVariant.options[optionIdx]);
    if (isDefaultTitle(selectedVariant.title)) multipleOccurrence = optionOccurrences[0];

    return multipleOccurrence ? multipleOccurrence.max : 0;
  };

  const setMultipleSlotsCount = (allow) => {
    if (allow) actions.setMultipleSlotsCount(multipleSlotsCount + 1);
  };

  const buildAddDateLabel = (label) => label.replace('{{count}}', getMax());

  const maxOccurrencesCount = getMax();
  const timeSlotsCount = timeSlots.length;
  const allowAddDate = multipleSlotsCount < maxOccurrencesCount
    && ((timeSlotsCount === 0 && timeSlot) || timeSlotsCount === multipleSlotsCount);
  const fontSize = font >= '16px' ? `calc(${font || '16px'} - 4px)` : '12px';
  const t = new Translation(props);
  const backgroundColor = allowAddDate ? buttonStyles.backgroundColor : style.inactive.backgroundColor;

  const buildBookingTime = (timeslot, index) => {
    const dir = rtlRegions.includes(region) ? 'rtl' : '';
    const startDate = timeslot ? new Date(timeslot.start) : new Date();
    const dateSelected = dayjs(startDate).tz(timeZone).locale(region).format(convertDateFormat(region));
    const startTime = formatHours(startDate, locale, timeZone, setting.timeFormat);

    if (!timeslot) {
      return (
      <div key="blank-timeslot">
        <span dir={dir} className="booking-time-label">
          <span>
            <Icon
              style={{ marginRight: '1em', color: '#c9e5aa' }}
              iconName="circleCheck"
            />
            { `${dateSelected.replace(/[a-z\d]/gi, '_')} ${startTime.replace(/[a-z\d]/gi, '_')}` }
          </span>
          <span></span>
        </span>
      </div>
      );
    }

    const available = isSlotAvailable(timeslot);
    const styles = available ? {} : { color: '#e6bbbc', textDecoration: 'line-through' };

    return (
      <div key={dayjs(startDate).format()}>
        <span dir={dir} className="booking-time-label" style={styles}>
          <span>
            <Icon
              style={{ marginRight: '1em', color: available ? '#c9e5aa' : '#e6bbbc' }}
              iconName={available ? 'circleCheck' : 'warning'}
            />
            { `${dateSelected} ${startTime}` }
          </span>
          <span>
            <StyledButton
              type="button"
              styled={{ ...buttonStyles, ...{ fontSize, backgroundColor } }}
              onClick={() => actions.removeTimeSlotByIndex(index)}
            >
              {CircleMinusMinor()}
            </StyledButton>
          </span>
        </span>
      </div>
    );
  };

  return (
    <MultipleAppointmentsWrapper>
      { (multipleSlotsCount > 1 || timeSlot)
        && (
          <>
            {/* <div className='recurring-checkbox'> */}
            {/*  <FormCheckbox */}
            {/*    name='recurring' */}
            {/*    value={recurringEnabled} */}
            {/*    onChange={actions.setRecurringMultipleSlots} */}
            {/*  /> */}
            {/*  <label className="control-label"> */}
            {/*    Recurring */}
            {/*  </label> */}
            {/* </div> */}
            <div className="booking-times">
              { multipleSlotsCount > 1
                ? timeSlots.map((timeslot, index) => buildBookingTime(timeslot, index))
                : buildBookingTime(timeSlot)}
              { (timeSlotsCount && multipleSlotsCount > timeSlotsCount)
                ? buildBookingTime(null)
                : ''}
            </div>
            <div className="add-another-date-container">
              <StyledButton
                type="button"
                styled={{ ...buttonStyles, ...{ fontSize, backgroundColor } }}
                onClick={() => setMultipleSlotsCount(allowAddDate)}
                disabled={!allowAddDate}
              >
                {CirclePlusMinor()}
              </StyledButton>

              { buildAddDateLabel(t.key('addAnotherDate') || 'Make another (max {{count}})') }
            </div>
          </>
        )}
    </MultipleAppointmentsWrapper>
  );
}

export default MultipleAppointments;
